import { ILabels, LabelsHelper } from "@iconics/localisation";

export default class Labels implements ILabels
{
    public helper!: LabelsHelper;

    public Attribute_Name = '';
    public Attribute_BuiltInType = '';
    public Attribute_IsArray = '';
    public Attribute_IsRequired = '';
    public Attribute_IsAddedToEntity = '';
    public DataHubCredentials_AccessKey = '';
    public DataHubCredentials_ConnectionString = '';
    public DataHubCredentials_DisplayName = '';
    public DataHubCredentials_Name = '';
    public DataHubPublisher_DataHubCredential_Id = '';
    public DataHubPublisher_DisplayName = '';
    public DataHubPublisher_ModuleConfiguration_Id = '';
    public DataHubPublisher_Name = '';
    public DataHubPublisher_PublishingType = '';
    public DataPoint_DataCollectionDeviceId = '';
    public DataPoint_DataPointDataType = '';
    public DataPoint_DataPointDataType_Enum = '';
    public DataPoint_DataPointDataType_Float = '';
    public DataPoint_DataPointDataType_Integer = '';
    public DataPoint_DataPointDataType_String = '';
    public DataPoint_DataPointName = '';
    public DataPoint_DataPointType = '';
    public DataPoint_DataPointType_Historical = '';
    public DataPoint_DataPointType_Realtime = '';
    public DataPoint_DisplayName = '';
    public DataPoint_Enabled = '';
    public DataPoint_Name = '';
    public DataPoint_SortOrder = '';
    public DataPoint_ValidationRangeMaximum = '';
    public DataPoint_ValidationRangeMinimum = '';
    public DataPoint_ValidationRule = '';
    public Entity_AuditLogDisabled = '';
    public Entity_DisplayName = '';
    public Entity_HistoryStorageMethod = '';
    public Entity_Name = '';
    public Entity_StorageType = '';
    public Entity_Package_ID = '';
    public Entity_StorageType_Cosmos = '';
    public Entity_StorageType_SQL = '';
    public Entity_StorageType_ADT = '';
    public Entity_HistoryStorageMethod_None = '';
    public Entity_HistoryStorageMethod_CosmosFullHistory = '';
    public Entity_HistoryStorageMethod_CosmosSingleRecordHistory = '';
    public Entity_HistoryStorageMethod_Audit = '';
    public Platform_Entity_ShowAllPackages = '';
    public Platform_Entity_HideAllPackages = '';
    public FadxNotSupportedByApi = '';
    public File_LastModified = '';
    public File_Path = '';
    public File_Size = '';
    public FileDropzone_Reset = '';
    public FileManagement_Path = '';
    public FileManagement_PathExists_Message = '';
    public funcAccept = '';
    public funcAdminDelegateSummary_D = '';
    public Platform_CommonAction_Decline = '';
    public Platform_CommonAction_Accept = '';
    public funcDelegateEmail_S = '';
    public funcDelegateName_S = '';
    public funcDelegatePermissions_S = '';
    public funcDelegates_S = '';
    public funcDelegateSummary_S = '';
    public funcDelegateYourAccountAccess_D = '';
    public funcDelegateYourAccountAccess_S = '';
    public funcDelegator_S = '';
    public funcDelegatorCannotDelegateSelf_L = '';
    public funcMustSelectDelegator_L = '';
    public funcNoDelegates_S = '';
    public funcNoUserSelected_S = '';
    public funcOutOfServiceDescription_S = '';
    public funcOutOfServiceTitle_S = '';
    public funcSearchDelegates_L = '';
    public funcSearchDelegates_S = '';
    public funcSearchDelegator_L = '';
    public funcSearchDelegator_S = '';
    public Platform_Delegates_Switch = '';
    public funcSwitchDelegator_D = '';
    public funcSwitchDelegator_S = '';
    public funcSystemUpgradedLogInAgain_L = '';
    public funcUnknown_S = '';
    public HierarchyParameter_IsEnabled = '';
    public HierarchyParameter_Name = '';
    public HierarchyParameter_DisplayName = '';
    public HierarchyParameter_OntologyNode_Name = '';
    public HierarchyParameter_ValueType = '';
    public HubLabelaccessDenied = '';
    public HubLabelaccessDeniedLabel = '';
    public HubLabelButtonJSONView = '';
    public HubLabelConfirmation = '';
    public HubLabelError = '';
    public HubLabelerrorSomethingWentWrong = '';
    public HubLabelFormat = '';
    public HubLabelIdentityProviderPlaceholderText = '';
    public HubLabelInvalidJSONMessage = '';
    public HubLabelJSONView = '';
    public HubLabelJSONViewDescription = '';
    public HubLabelNameOrEmailLabel = '';
    public HubLabelnetworkFailure = '';
    public HubLabelNoRights = '';
    public HubLabelPleaseTryAgain = '';
    public HubLabelSomethingWentWrong = '';
    public HubLabelSuccess = '';
    public HubLabelUnauthorisedMessage = '';
    public HubLabelUpdate = '';
    public HubLabelUserPermissionCol1 = '';
    public HubLabelUserPermissionCol2 = '';
    public HubLabelUserPermissionDescriptionCol1 = '';
    public HubLabelUserPermissionDescriptionCol2 = '';
    public HubMenuAdminPortal = '';
    public HubMenuNotifications = '';
    public IdentityProvider_AdditionalAudiences = '';
    public IdentityProvider_ClientId = '';
    public IdentityProvider_ClientSecret = '';
    public IdentityProvider_DisplayName = '';
    public IdentityProvider_IdentityProviderId = '';
    public IdentityProvider_IsDefault = '';
    public IdentityProvider_LastSync = '';
    public IdentityProvider_LastSyncStatus = '';
    public IdentityProvider_MaxPasswordAge = '';
    public IdentityProvider_MinPasswordLength = '';
    public IdentityProvider_Name = '';
    public IdentityProvider_NameClaimType = '';
    public IdentityProvider_PasswordComplexity = '';
    public IdentityProvider_PasswordComplexity_AnyType = '';
    public IdentityProvider_PasswordComplexity_FourDifferentTypes = '';
    public IdentityProvider_PasswordComplexity_ThreeDifferentTypes = '';
    public IdentityProvider_PasswordComplexity_TwoDifferentTypes = '';
    public IdentityProvider_ScimAccessTokenButtonDisabled_Tooltip = '';
    public IdentityProvider_ScimSecurityToken = '';
    public IdentityProvider_SecurityProviderTypeId = '';
    public IdentityProvider_SecurityProviderTypeId_AAD = '';
    public IdentityProvider_SecurityProviderTypeId_Native = '';
    public IdentityProvider_SecurityProviderTypeId_Okta = '';
    public IdentityProvider_SecurityProviderTypeId_Auth0 = '';
    public IdentityProvider_SecurityProviderTypeId_B2C = '';
    public IdentityProvider_SyncType = '';
    public IdentityProvider_TenantDomain = '';
    public IdentityProvider_TenantId = '';
    public IdentityProviders_ScimAccessToken = '';
    public IdentityProviders_ScimAccessTokenDialog_Title = '';
    public IdentityProviders_SyncType_GraphAPI = '';
    public IdentityProviders_SyncType_GroupsClaimSync = '';
    public IdentityProviders_SyncType_None = '';
    public IdentityProviders_SyncType_SCIMv2 = '';
    public Node_DisplayName = '';
    public Node_Id = '';
    public Node_IsEnabled = '';
    public Node_Name = '';
    public Node_OntologyNode = '';
    public Node_Parent_Id = '';
    public Node_SortOrder = '';
    public Node_TimeZoneDST = '';
    public Node_TimeZoneType = '';
    public Nodes_TimeZone = '';
    public Notification_Bcc = '';
    public Notification_Cc = '';
    public Notification_Disabled = '';
    public Notification_EventTypeName = '';
    public Notification_IsHTML = '';
    public Notification_Message = '';
    public Notification_MobilePushAction = '';
    public Notification_MobilePushActionUri = '';
    public Notification_MobilePushBadge = '';
    public Notification_MobilePushMessage = '';
    public Notification_MobilePushTitle = '';
    public Notification_MobilePushTo = '';
    public Notification_Name = '';
    public Notification_NotificationArea = '';
    public Notification_NotificationArea_Generic = '';
    public Notification_NotificationArea_IBSS_Bookings = '';
    public Notification_NotificationArea_IBSS_Tasks = '';
    public Notification_NotificationArea_IBSS_Visitors = '';
    public Notification_ReplyTo = '';
    public Notification_RuleExpression = '';
    public Notification_ShouldSendEmail = '';
    public Notification_ShouldSendMobilePush = '';
    public Notification_Subject = '';
    public Notification_To = '';
    public NumberHelper_Bytes = '';
    public NumberHelper_GigaBytes = '';
    public NumberHelper_KiloBytes = '';
    public NumberHelper_MegaBytes = '';
    public NumberHelper_TeraBytes = '';
    public Ontology_Description = '';
    public Ontology_DisplayName = '';
    public Ontology_EntityName = '';
    public Ontology_IsEnabled = '';
    public Ontology_Name = '';
    public OntologyNode_DisplayName = '';
    public OntologyNode_IsEnabled = '';
    public OntologyNode_IsRecursive = '';
    public OntologyNode_IsRequired = '';
    public OntologyNode_Name = '';
    public OntologyNode_Parent = '';
    public Package_Description = '';
    public Package_DisplayName = '';
    public Package_IsEnabled = '';
    public Package_Name = '';
    public Parameter_IsEnabled = '';
    public Parameter_Name = '';
    public Parameter_Value = '';
    public Parameter_ValueType = '';
    public Platform_EditSolutions_AddPackageTitle = '';
    public Platform_AddFile_DropZone_Message = '';
    public Platform_AddFile_SelectFile = '';
    public Platform_AddFile_Title = '';
    public Platform_AddFile_Upload = '';
    public Platform_AddSelectImage = '';
    public Platform_Attribute_PageTitle = '';
    public Platform_AssetWorX_Add = '';
    public Platform_AssetWorX_Delete = '';
    public Platform_AssetWorX_Edit = '';
    public Platform_AssetWorX_EditNodeSolutions_HierarchyParameterSubTitle = '';
    public Platform_AssetWorX_EditNodeSolutions_HierarchyParameterTitle = '';
    public Platform_AssetWorX_MenuTitle = '';
    public Platform_AssetWorX_NodeHierarchySubTitle = '';
    public Platform_AssetWorX_NodeHierarchyTitle = '';
    public Platform_ChangePassword_New1 = '';
    public Platform_ChangePassword_New2 = '';
    public Platform_ChangePassword_Original = '';
    public Platform_ChangePassword_PasswordsMustBeEqual = '';
    public Platform_ChangePassword_SubTitle = '';
    public Platform_ChangePassword_Title = '';
    public Platform_ChangePassword_Success = '';
    public Platform_CommonAction_Add = '';
    public Platform_CommonAction_Back = '';
    public Platform_CommonAction_Cancel = '';
    public Platform_CommonAction_Delete = '';
    public Platform_CommonAction_Disable = '';
    public Platform_CommonAction_Download = '';
    public Platform_CommonAction_Edit = '';
    public Platform_CommonAction_Enable = '';
    public Platform_CommonAction_Next = '';
    public Platform_CommonAction_Ok = '';
    public Platform_CommonAction_Save = '';
    public Platform_CommonAction_Search = '';
    public Platform_CommonAction_Submit = '';
    public Platform_Common_Success = '';
    public Platform_Configuration_MenuTitle = '';
    public Platform_ConfirmDelete_Message = '';
    public Platform_ConfirmDelete_Title = '';
    public Platform_Copyright = '';
    public Platform_Disabled = '';
    public Platform_DataCredentials_MenuTitle = '';
    public Platform_DataExchange_MenuTitle = '';
    public Platform_DataHubCredential_ConfirmDeleteMsg = '';
    public Platform_DataHubCredentials_DetailsSubTitle = '';
    public Platform_DataHubCredentials_DetailsTitle = '';
    public Platform_DataHubCredentials_ListSubTitle = '';
    public Platform_DataHubCredentials_ListTitle = '';
    public Platform_DataHubCredentials_PageTitle = '';
    public Platform_DataHubCredentials_Required = '';
    public Platform_DataHubPublisher_ConfirmDeleteMsg = '';
    public Platform_DataHubPublisher_DetailsSubTitle = '';
    public Platform_DataHubPublisher_DetailsTitle = '';
    public Platform_DataHubPublisher_ListSubTitle = '';
    public Platform_DataHubPublisher_ListTitle = '';
    public Platform_DataHubPublisher_PageTitle = '';
    public Platform_DataHubPublisher_Required = '';
    public Platform_DataModel_MenuTitle = '';
    public Platform_DataPoint_ConfirmDeleteMsg = '';
    public Platform_DataPoint_ConnectivitySubTitle = '';
    public Platform_DataPoint_ConnectivityTitle = '';
    public Platform_DataPoint_DetailsSubTitle = '';
    public Platform_DataPoint_DetailsTitle = '';
    public Platform_DataPoint_PageTitle = '';
    public Platform_DataPoint_Required = '';
    public Platform_DataPublishers_MenuTitle = '';
    public Platform_Delegates_MenuTitle = '';
    public Platform_Diagnostics_ReleaseVersion = '';
    public Platform_Diagnostics_Title = '';
    public Platform_Entity_PageTitle = '';
    public Platform_Entity_DetailsTitle = '';
    public Platform_Entity_DetailsSubTitle = '';
    public Platform_Entity_AttributeListTitle = '';
    public Platform_Entity_AttributeListSubTitle = '';
    public Platform_Entity_RemoveAttributes = ''
    public Platform_Entity_AddAttributes = ''
    public Platform_Entity_ShowAllAttributes = ''
    public Platform_Entity_HideAllAttributes = ''
    public Platform_Entity_SetPrimaryKey = '';
    public Platform_Entity_SetTimestamp = '';
    public Platform_Attribute_DetailsTitle = '';
    public Platform_Attribute_DetailsSubTitle = '';
    public Platform_Entity_Attribute_PrimaryKeyIsRequired = '';
    public Platform_Entity_Attribute_TimestampIsRequired = '';
    public Platform_Entity_Attribute_TimestampMustBeDateTime = '';
    public Platform_Entity_Attribute_PrimaryKeyAndTimestampMustBeDifferent = '';
    public Platform_Entity_Attribute_CannotRemovePrimaryKeyOrTimestamp = '';
    public Platform_FileManagement_ListSubTitle = '';
    public Platform_FileManagement_ListTitle = '';
    public Platform_FileManagement_PageTitle = '';
    public Platform_Files_MenuTitle = '';
    public Platform_Home_Description = '';
    public Platform_Home_DetailsSubTitle = '';
    public Platform_Home_DetailsTitle = '';
    public Platform_Home_MenuTitle = '';
    public Platform_Home_PageTitle = '';
    public Platform_IdentityProvider_AADDetailsSubTitle = '';
    public Platform_IdentityProvider_AADDetailsTitle = '';
    public Platform_IdentityProvider_CommonDetailsSubTitle = '';
    public Platform_IdentityProvider_CommonDetailsTitle = '';
    public Platform_IdentityProvider_ConfirmDeleteMsg = '';
    public Platform_IdentityProvider_Edit_Required = '';
    public Platform_IdentityProvider_LastSyncShowError = '';
    public Platform_IdentityProvider_ListSubTitle = '';
    public Platform_IdentityProvider_ListTitle = '';
    public Platform_IdentityProvider_NativeDetailsSubTitle = '';
    public Platform_IdentityProvider_NativeDetailsTitle = '';
    public Platform_IdentityProvider_OktaDetailsSubTitle = '';
    public Platform_IdentityProvider_OktaDetailsTitle = '';
    public Platform_IdentityProvider_PageTitle = '';
    public Platform_IdentityProvider_SyncNow = '';
    public Platform_IdentityProvider_SyncNow_Error = '';
    public Platform_IdentityProvider_SyncNow_Success = '';
    public Platform_IdentityProvider_ZeroNotAcceptable = '';
    public Platform_IdentityProviders_MenuTitle = '';
    public Platform_IdentityProviders_SyncType_GraphAPI_SubTitle = '';
    public Platform_IdentityProviders_SyncType_GraphAPI_Title = '';
    public Platform_IdentityProviders_SyncType_SCIMv2_SubTitle = '';
    public Platform_IdentityProviders_SyncType_SCIMv2_Title = '';
    public Platform_ImageNameExistsError = '';
    public Platform_ImageSelection = '';
    public Platform_Invalid_Field = '';
    public Platform_LanguageMenu_Unknown = '';
    public Platform_LanguageMenu_English = '';
    public Platform_LanguageMenu_Japanese = '';
    public Platform_LanguageMenu_Language = '';
    public Platform_LanguageMenu_SubTitle = '';
    public Platform_LanguageMenu_Terms = '';
    public Platform_LanguageMenu_Title = '';
    public Platform_Login_ContinueToLogin = '';
    public Platform_Login_Email = '';
    public Platform_Login_EnterEmailMessage = '';
    public Platform_Login_EnterPasswordMessage = '';
    public Platform_Login_ForgottenPassword = '';
    public Platform_Login_IncorrectEmailError = '';
    public Platform_Login_Login = '';
    public Platform_Login_LogInAgain = '';
    public Platform_Login_LoginFailed = '';
    public Platform_Login_LoginFailedPleaseTryAgain = '';
    public Platform_Login_NoPermissionToLogIn = '';
    public Platform_Login_PageSubTitle = '';
    public Platform_Login_PageTitle = '';
    public Platform_Login_Password = '';
    public Platform_Login_PolicySubTitle = '';
    public Platform_Login_RequestNewPassword = '';
    public Platform_Login_SignInText = '';
    public Platform_Login_UnableToLoginMessage = '';
    public Platform_Login_WelcomeToHub = '';
    public Platform_MultilingualTextField_SubTitle = '';
    public Platform_MultilingualTextField_Title = '';
    public Platform_Node_AddOntologyNodeDetails = '';
    public Platform_Node_AddOntologyNodeSubTitle = '';
    public Platform_Node_AddOntologyNodeTitle = '';
    public Platform_Node_ConfirmDeleteMsg = '';
    public Platform_Node_DataPointListSubTitle = '';
    public Platform_Node_DataPointListTitle = '';
    public Platform_Node_DetailsSubTitle = '';
    public Platform_Node_DetailsTitle = '';
    public Platform_Node_EditParameterDetails = '';
    public Platform_Node_EditParameterSubTitle = '';
    public Platform_Node_EditParameterTitle = '';
    public Platform_Node_MetaDataListSubTitle = '';
    public Platform_Node_MetaDataListTitle = '';
    public Platform_Node_OntologyNodeListSubTitle = '';
    public Platform_Node_OntologyNodeListTitle = '';
    public Platform_Node_PageTitle = '';
    public Platform_NodeOntologyNode_ConfirmDeleteMsg = '';
    public Platform_Nodes_MenuTitle = '';
    public Platform_Notification_ConfirmDeleteMsg = '';
    public Platform_Notification_DetailsSubTitle = '';
    public Platform_Notification_DetailsTitle = '';
    public Platform_Notification_ListSubTitle = '';
    public Platform_Notification_ListTitle = '';
    public Platform_Notification_PageTitle = '';
    public Platform_Notification_SendEmailDetailsSubTitle = '';
    public Platform_Notification_SendEmailDetailsTitle = '';
    public Platform_Notification_SendPushDetailsSubTitle = '';
    public Platform_Notification_SendPushDetailsTitle = '';
    public Platform_Notifications_MenuTitle = '';
    public Platform_Ontology_ConfirmDeleteMsg = '';
    public Platform_Ontology_DetailsSubTitle = '';
    public Platform_Ontology_DetailsTitle = '';
    public Platform_Ontology_EditOntologyNodeDetails = '';
    public Platform_Ontology_EditOntologyNodeSubTitle = '';
    public Platform_Ontology_EditOntologyNodeTitle = '';
    public Platform_Ontology_ListSubTitle = '';
    public Platform_Ontology_ListTitle = '';
    public Platform_Ontology_NodeListSubTitle = '';
    public Platform_Ontology_NodeListTitle = '';
    public Platform_Ontology_PageTitle = '';
    public Platform_OntologyNode_ConfirmDeleteMsg = '';
    public Platform_Package_ConfirmDeleteMsg = '';
    public Platform_Package_Description = '';
    public Platform_Package_DetailsSubTitle = '';
    public Platform_Package_DetailsTitle = '';
    public Platform_Package_EntityListSubTitle = '';
    public Platform_Package_EntityListTitle = '';
    public Platform_Package_IsEnabled = '';
    public Platform_Package_ListSubTitle = '';
    public Platform_Package_ListTitle = '';
    public Platform_Package_Name = '';
    public Platform_Package_PageTitle = '';
    public Platform_Package_SolutionListSubTitle = '';
    public Platform_Package_SolutionListTitle = '';
    public Platform_Packages_MenuTitle = '';
    public Platform_RedirectionStatus_SubTitle = '';
    public Platform_RedirectionStatus_Title = '';
    public Platform_Relationship_ConfirmDeleteMsg = '';
    public Platform_Relationship_DetailsSubTitle = '';
    public Platform_Relationship_DetailsTitle = '';
    public Platform_Relationship_ListSubTitle = '';
    public Platform_Relationship_ListTitle = '';
    public Platform_Relationship_PageTitle = '';
    public Platform_Relationships_MenuTitle = '';
    public Platform_Required = '';
    public Platform_Role_AppActionsSubTitle = '';
    public Platform_Role_AppActionsTitle = '';
    public Platform_Role_ConfirmDeleteMsg = '';
    public Platform_Role_DataSecurityDetailsSubTitle = '';
    public Platform_Role_DataSecurityDetailsTitle = '';
    public Platform_Role_DetailsSubTitle = '';
    public Platform_Role_DetailsTitle = '';
    public Platform_Role_ListSubTitle = '';
    public Platform_Role_ListTitle = '';
    public Platform_Role_PageTitle = '';
    public Platform_Role_Security_Create = '';
    public Platform_Role_Security_Delete = '';
    public Platform_Role_Security_Level0 = '';
    public Platform_Role_Security_Level1 = '';
    public Platform_Role_Security_Level2 = '';
    public Platform_Role_Security_Level3 = '';
    public Platform_Role_Security_Level4 = '';
    public Platform_Role_Security_Lock = '';
    public Platform_Role_Security_Read = '';
    public Platform_Role_Security_Share = '';
    public Platform_Role_Security_Unlock = '';
    public Platform_Role_Security_Update = '';
    public Platform_Role_UserListSubTitle = '';
    public Platform_Role_UserListTitle = '';
    public Platform_Roles_MenuTitle = '';
    public Platform_Role_AssignUser = '';
    public Platform_Role_UnassignUser = '';
    public Platform_Role_ShowAllUsers = '';
    public Platform_Role_HideAllUsers = '';
    public Platform_SelectedImage = '';
    public Platform_Setup_MenuTitle = '';
    public Platform_Shared_Required = '';
    public Platform_Solution_ConfirmDeleteMsg = '';
    public Platform_Solution_DetailsSubTitle = '';
    public Platform_Solution_DetailsTitle = '';
    public Platform_Solution_ListSubTitle = '';
    public Platform_Solution_ListTitle = '';
    public Platform_Solution_MetaDataListSubTitle = '';
    public Platform_Solution_MetaDataListTitle = '';
    public Platform_Solution_PackageListSubTitle = '';
    public Platform_Solution_PackageListTitle = '';
    public Platform_Solution_PageTitle = '';
    public Platform_Solution_Required = '';
    public Platform_SolutionEnablement_ListSubTitle = '';
    public Platform_SolutionEnablement_ListTitle = '';
    public Platform_SolutionEnablement_MenuTitle = '';
    public Platform_SolutionEnablement_PageTitle = '';
    public Platform_SolutionPackage_ConfirmDeleteMsg = '';
    public Platform_SolutionParameter_ConfirmDeleteMsg = '';
    public Platform_Solutions_MenuTitle = '';
    public Platform_SystemOntologies_MenuTitle = '';
    public Platform_Tenancies_MenuTitle = '';
    public Platform_Tenancy_ConfirmDeleteMsg = '';
    public Platform_Tenancy_DetailsSubTitle = '';
    public Platform_Tenancy_DetailsTitle = '';
    public Platform_Tenancy_ListSubTitle = '';
    public Platform_Tenancy_ListTitle = '';
    public Platform_Tenancy_MenuTitle = '';
    public Platform_Tenancy_PageTitle = '';
    public Platform_Tenancy_Required = '';
    public Platform_TenancyOntologies_MenuTitle = '';
    public Platform_Tenancy_UserDetailsTitle = '';
    public Platform_Tenancy_UserDetailsSubTitle = '';
    public Platform_Tenancy_AdminEmail_1 = '';
    public Platform_Tenancy_AdminEmail_2 = '';
    public Platform_Tenancy_AdminEmail2_MustEqualAdminEmail1 = ''
    public Platform_Tenancy_AdminEmail_Advice = '';
    public Platform_ThemeMenu_Asagi = '';
    public Platform_ThemeMenu_Konjo = '';
    public Platform_ThemeMenu_Kurikawa = '';
    public Platform_ThemeMenu_SubTitle = '';
    public Platform_ThemeMenu_Sumire = '';
    public Platform_ThemeMenu_Theme = '';
    public Platform_ThemeMenu_Title = '';
    public Platform_ThemeMenu_Tsutsji = '';
    public Platform_Common_MandatoryField = '';
    public Platform_Common_MustBeNumber = '';
    public Platform_Common_MustBeEqualTo = '';
    public Platform_Common_MustBeGreaterThan = '';
    public Platform_Common_MustBeMaxLength = '';
    public Platform_Common_InvalidEmailFormat = '';
    public Platform_Toast_CopiedToClipboard = '';
    public Platform_User_ConfirmDeleteMsg = '';
    public Platform_User_DetailsSubTitle = '';
    public Platform_User_DetailsTitle = '';
    public Platform_User_UnassignRole = '';
    public Platform_User_AssignRole = '';
    public Platform_User_HideAvailableRoles = '';
    public Platform_User_ListSubTitle = '';
    public Platform_User_ListTitle = '';
    public Platform_User_PageTitle = '';
    public Platform_User_PreferencesSubTitle = '';
    public Platform_User_PreferencesTitle = '';
    public Platform_User_ResetPassword = '';
    public Platform_User_RoleListSubTitle = '';
    public Platform_User_RoleListTitle = '';
    public Platform_User_ShowAvailableRoles = '';
    public Platform_UserMenu_ChangeLanguage = '';
    public Platform_UserMenu_ChangePassword = '';
    public Platform_UserMenu_ChangeTheme = '';
    public Platform_UserMenu_Diagnostics = '';
    public Platform_UserMenu_Logout = '';
    public Platform_Users_Edit_PasswordResetSuccess = '';
    public Platform_Users_Edit_Required = '';
    public Platform_Users_Edit_UserPreferencesInvalid = '';
    public Platform_Users_MenuTitle = '';
    public Platform_VirtualTreeView_ConfirmDeleteMsg = '';
    public Platform_VirtualTreeView_DetailsSubTitle = '';
    public Platform_VirtualTreeView_DetailsTitle = '';
    public Platform_VirtualTreeView_ListSubTitle = '';
    public Platform_VirtualTreeView_ListTitle = '';
    public Platform_VirtualTreeView_PageTitle = '';
    public Platform_VirtualTreeViews_MenuTitle = '';
    public Relationship_Description = '';
    public Relationship_DisplayName = '';
    public Relationship_IsEnabled = '';
    public Relationship_Name = '';
    public Relationship_Primary2SecondaryRelation = '';
    public Relationship_Secondary2PrimaryRelation = '';
    public Role_DisplayName = '';
    public Role_GroupId = '';
    public Role_IdentityProviderId = '';
    public Role_IsEnabled = '';
    public Role_IsOwner = '';
    public Role_Name = '';
    public Role_IsAssignedToUser = '';
    public Solution_ApplicationUri = '';
    public Solution_Description = '';
    public Solution_DisplayName = '';
    public Solution_EntityName = '';
    public Solution_IconUri = '';
    public Solution_ImageUri = '';
    public Solution_IsEnabled = '';
    public Solution_Name = '';
    public Solution_Ontology = '';
    public Solution_OrderSequence = '';
    public Solution_ShowOnHomePage = '';
    public Solution_ShowOnMenu = '';
    public Tenancy_DisplayName = '';
    public Tenancy_IsEnabled = '';
    public Tenancy_Name = '';
    public User_DisplayName = '';
    public User_Email = '';
    public User_FirstName = '';
    public User_IdentityProviderName = '';
    public User_LastName = '';
    public User_PhoneNumber = '';
    public User_PreferredName = '';
    public User_UserLocation = '';
    public User_UserPassword = '';
    public User_ApplicationKey = '';
    public User_UserPreferences = '';
    public User_UserType = '';
    public User_UserType_Application = '';
    public User_UserType_User = '';
    public User_IsAssignedToRole = '';
    public VirtualTreeView_Definition = '';
    public VirtualTreeView_Description = '';
    public VirtualTreeView_DisplayName = '';
    public VirtualTreeView_IsEnabled = '';
    public VirtualTreeView_Name = '';
    public VirtualTreeView_OntologyId = '';
    public Platform_DataHubPublisher_DataEntitySelectionTitle = '';
    public Platform_DataHubPublisher_DataEntitySelectionSubTitle = '';
    public DataHubPublisher_DataPackage = '';
    public DataHubPublisher_Entity = '';
    public DataHubPublisher_Entity_PublishingType = '';
    public Platform_DataHubPublisher_PublishingType_EventHub = '';
    public Platform_DataHubPublisher_PublishingType_EventGrid = '';
    public Platform_DataHubPublisher_PublishingType_AzureFunction = '';
    public Platform_DataEntity_PublishingType_None = '';
    public Platform_DataEntity_PublishingType_Whole = '';
    public Platform_IdentityProvider_B2CDetailsTitle = '';
    public Platform_IdentityProvider_B2CDetailsSubTitle = '';
    public Platform_IdentityProvider_Auth0DetailsTitle = '';
    public Platform_IdentityProvider_Auth0DetailsSubTitle = '';
    public User_Initials = '';
    public Platform_User_ConfigurationTitle = '';
    public Platform_User_ConfigurationSubTitle = '';
    public Role_IsConfigurable = '';
    public Platform_AssetWorX_Import = '';
    public Platform_AssetWorX_ImportSuccess = '';
    public Platform_AssetWorX_ImportPartialSuccess = '';
    public Platform_AssetWorX_ImportSuccess_Message = '';
    public Platform_AssetWorX_ImportPartialSuccess_Message = '';
    public Platform_Nodes_ImportDialog_Title = '';
    public Platform_Nodes_ImportDialog_SubTitle = '';
    public Platform_Nodes_ImportDialog_FileType = '';
    public Platform_Nodes_ImportDialog_Node = '';
    public Platform_Nodes_ImportDialog_FileDropZone_Title = '';
    public Platform_Nodes_ImportDialog_FileDropZone_SubTitle = '';
    public Platform_Nodes_ImportDialog_UpdateExisting = '';
    public Platform_Nodes_ImportDialog_ContinueOnError = '';
    public Platform_Nodes_ImportDialog_ContinueOnError_HelperText = '';
    public Platform_Nodes_ImportDialog_UpdateExisting_HelperText = '';
    public Platform_Nodes_ImportDialog_ImportOptions_Title = '';
    public ImportFormat_GenesisAssetCatalogue = '';
    public ImportFormat_NodesConfiguration = '';
    public ImportFormat_ControlPlan = '';
}
